module.exports = __webpack_public_path__ + "static/media/switzerland.32de4ca7.svg";